const notificationConfig = {
  deleteConfirmText:
    'This action will delete the following Timed Message Request',
  note: 'NOTE: The timed message once deleted will not be retrieved',

  templatePattern: {
    setDefault:
      'This action will set the selected Template Pattern as the default for all associated partners',
    listAll:
      'This action will list the Template Pattern for all associated partners',
  },

  walkup: {
    songMappingInstruction:
      'Select the Player and then choose the song you want and click the "+" sign.',
    choosePlayerInputMethod:
      'You can upload an existing roster using the sample format provided, choose from players that were previously added, or add manually one by one.',
    enterPlayerPreAnnouncement:
      'You can select a pre-announcement from the drop down menu or leave it blank if you do not want a pre-announcement recorded.',
    arrangePlayerOrder:
      'Drag and drop the players into the order you would like them, and then click "submit".',
    previewInstructions: [
      'Click the "Play" button to hear the system recording of the player announcement.',
      'If you want to generate another version, click the forward ">>" symbol, and listen again. The system will generate up to 4 versions for your review.',
      "IMPORTANT: The version you are on when you click 'next' is the one that will get sent for processing.",
      'If after 4 tries, the recording still does not sound correct, click the microphone icon and either record the pronunciation you want or provide phonetic spelling in the space provided. We will manually record the announcement and add it to your station.',
    ],
    finalRecordingSuccessMsg:
      'The final recording of all elements combined will be available in Voyager and on your player after processing is complete',
  },

  backNavigationDialog: {
    dialog:
      'If you close this window now you will lose all of your current work.',
    action: 'Click Agree to close out or cancel to continue with this request',
  },

  createClipsDeleteConfirm: {
    title: 'Delete Custom clips -',
    note: 'Please note that this action is irreversible',
    message:
      'You are about to permanently delete the following custom clip from your station,',
    linkedWarning:
      'this will delete / remove the clip from all the libraries/ playlists.',
    unlinkedMessage:
      'This custom clip is not associated with any libraries or playlists.',
  },
  wristbandDelete: {
    dialog: 'Permanently delete the following schedules:',
  },
};

export default notificationConfig;
